import type { ComponentProps, ReactNode } from 'react';
import { cn } from '../../lib/utils';
import { useFieldContext, FieldInfo } from './shared';
import { Checkbox } from '../checkbox';
import { Label } from '../label';

export function CheckboxField({
	label,
	acceptIndeterminate,
	className,
	...props
}: ComponentProps<'button'> & { label?: ReactNode; acceptIndeterminate?: boolean }) {
	const field = useFieldContext<boolean | null>();

	return (
		<div>
			<div className={cn('text-muted-foreground flex items-start gap-4', className)}>
				<Checkbox
					id={field.name}
					name={field.name}
					checked={field.state.value ?? 'indeterminate'}
					onBlur={field.handleBlur}
					onCheckedChange={() => {
						if (acceptIndeterminate) {
							field.handleChange(field.state.value === false ? true : field.state.value === true ? null : false);
						} else {
							field.handleChange(!field.state.value);
						}
					}}
					{...props}
				/>
				{label && (
					<Label
						data-slot="form-label"
						data-error={field.state.meta.isTouched && !field.state.meta.isValid}
						className="data-[error=true]:text-destructive"
						htmlFor={field.name}
					>
						{label}
					</Label>
				)}
			</div>
			<FieldInfo fieldState={field.state} />
		</div>
	);
}
